// Loan eligibility pre-check.
//
// This used to re-implement the entire pricing engine client-side (income
// engine, scoring, interest-rate selection, eligible-amount, fees) — one of
// three copies of the same math (the other two being staff-portal and the
// loan-service submit paths), which could and did drift.
//
// It now delegates to the single source of truth on loan-service:
//   POST /v2/loans/client/apply/:slug?mode=preview
// which runs the exact same engine the commit path uses and returns the quote
// { status, loanAmt, score, interestRate, paymentFreq, paymentObj, reason }
// without persisting anything. See loan-service evaluate* + the shared
// constants served from /v2/config (loan-service/utils/all-constants.js).

import { store } from 'providers/store';
import { fetchRequests } from 'https/requests';
import { STAGING_LOAN } from 'config/env';

async function preCheckLoanEligibility(loanType, data) {
    const accessToken = store.getState().user.accessToken;
    const headers = {
        'authorization': `${accessToken}`,
        'Content-Type': 'application/json',
    };

    // Backend client routes are lowercase-with-hyphens (loanme, pension,
    // pencash, capitalme, cediscredit, investment, payroll, salaried,
    // salaried-advance); the callers pass "loanMe" etc, so normalize the slug.
    const slug = loanType.toLowerCase();

    // mode=preview runs the engine without persisting.
    return await fetchRequests(
        `${STAGING_LOAN}/apply/${slug}`,
        'post',
        headers,
        { mode: 'preview' },
        data
    );
}

export {
    preCheckLoanEligibility
}
